// extracted by mini-css-extract-plugin
export default {"wrongDepth":"CorrectDepth_wrongDepth__4FnWz","warningDepth":"CorrectDepth_warningDepth__BWjt7"};